import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { pathOr } from 'ramda';

type ICalltrackingPlaceTypes = 'cardBottom' | 'sidePanel';

interface IDynamicCalltrackingParams {
  httpApi: IHttpApi;
  logger: ILogger;
  blockId: number;
  placeType: string;
  announcementId?: number;
  queryString?: string;
  dynamicCalltrackingPlaceType?: ICalltrackingPlaceTypes;
}

export async function getDynamicCalltrackingPhone({
  placeType = 'card',
  ...params
}: IDynamicCalltrackingParams): Promise<{
  phone: string | null;
}> {
  const response = await handleDynamicCalltracking({
    ...params,
    platformType: EPlatformTypes.WebDesktop,
    pageType: EPageTypes.OfferList,
    placeType,
  });

  return {
    phone: pathOr(null, ['notFormattedPhone'], response),
  };
}
